import React from 'react';
import {connect} from 'react-redux';

import './styles.scss';
import byttelydAvatar from '../Tulleordtesten/assets/byttelyd.png';

import {
	goToNextStep,
	setTestStepAnswers,
	setIsSendingTestResultsToFalse,
} from 'actions/index';

import {TEST_STEPS} from 'constants/index';

import Intro from './Intro';
import Test from './Test';
import strings from 'utils/strings';

const subSteps = [Intro, Test];
class OrdforstaelseTesten extends React.Component {
	constructor() {
		super();

		this.handleNextSubstep = this.handleNextSubstep.bind(this);

		this.state = {
			isSubmitting: false,
			currentSubstepIndex: 0,
			showAvatar: true,
		};
		this.audioRefs = {};
	}

	handleNextSubstep(results) {
		const {currentSubstepIndex} = this.state;
		const {candidateGrade, isDldTest} = this.props;

		const {
			onGoToNextStep,
			onSetTestStepAnswers,
			onSetIsSendingTestResultsToFalse,
		} = this.props;

		const isLastStep = currentSubstepIndex === subSteps.length - 1;

		if (isLastStep) {
			const resultKeys = Object.keys(results);
			const formattedResults = resultKeys.map((id, index) => {
				const value = results[id];
				return {
					id: isDldTest ? `${index + 1}` : id,
					value,
				};
			});
			onSetTestStepAnswers(
				TEST_STEPS.ORDFORSTÅELSE,
				formattedResults,
				candidateGrade
			)
				.then(() => {
					if (!this.state.isSubmitting) {
						this.setState({isSubmitting: true});
						onSetIsSendingTestResultsToFalse();
						onGoToNextStep();
					}
				})
				.catch(() => {
					this.setState({isSubmitting: false});
				});
		} else {
			this.setState({
				currentSubstepIndex: currentSubstepIndex + 1,
			});
			setTimeout(() => {
				window.scrollTo(0, 0);
			});
		}
	}

	render() {
		const {currentSubstepIndex} = this.state;

		const CurrentSubStep = subSteps[currentSubstepIndex];

		return (
			<div className="lit-intro lit-avatar-test">
				{this.state.showAvatar && (
					<div className="avatar-img">
						<img className="adminItem" src={byttelydAvatar} alt=""></img>
					</div>
				)}
				{currentSubstepIndex === 0 && (
					<h1 className="lit-page-title">{strings.ordforstaelse}</h1>
				)}
				<CurrentSubStep
					onNextStep={this.handleNextSubstep}
					onShowAvatar={(flag) => this.setState({showAvatar: flag})}
					refs={this.audioRefs}
					candidateGrade={this.props.candidateGrade}
					isDldTest={this.props.isDldTest}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {candidateGrade} = state;
	return {
		candidateGrade,
	};
};

const mapDispatchToProps = {
	onGoToNextStep: goToNextStep,
	onSetTestStepAnswers: setTestStepAnswers,
	onSetIsSendingTestResultsToFalse: setIsSendingTestResultsToFalse,

};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(OrdforstaelseTesten);
